import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_ALL_GROUPS: '/MobilSettingsList',
  UPDATE_GROUP: '/MobilSettingsUpdate'
};

export const getAllSettings = async () => {
  try {
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_GROUPS);
    if (response.data && response.data.status === 200) {
      const users = response.data.data;
      if (Array.isArray(users)) {
        return users;
      }
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};
 
 

export const updateSettings = async (userId, userData) => {
  try {
    const formData = new FormData();
    formData.append('Context', userData.context);   

    const response = await axiosInstance.post(`${ENDPOINTS.UPDATE_GROUP}/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to update user');
  } catch (error) {
    console.error('Update user error:', error);
    throw error;
  }
};
